<template>

  <div>

    <CartItems :isOpen="cartNavbar"></CartItems>

    <VideoPopup
        v-if="customerSettings.setting && customerSettings.setting.section1VideoUrl"
        :isPopupActive="videoPopUp"
        :youtubeLink="customerSettings.setting.section1VideoUrl" 
        @closeVideoPopUp="toggleVideoPopUp"
    />

    <!-- Section 1 -->
    <section ref="homepage" class="relative w-full h-auto bg-no-repeat bg-cover"
      :style="customerSettings.setting && customerSettings.setting.welcomeSectionBackgroundImage != '' ? { backgroundImage: 'url(' + customerSettings.setting.welcomeSectionBackgroundImage + ')' } : ''" >

        <div class="absolute inset-0 z-0 h-full bg-purple-700 opacity-25"></div>

        <Navbar
          v-on:goToSectionById="onGoToSectionById"
          :isHomePage="true"
        ></Navbar>
        
        <!--  Mobile Bottom Menu -->
        <div v-show="!showMobileMenu" class="fixed bottom-0 z-40 w-full bg-white md:hidden">
          <div class="w-full flex flex-row gap-2 p-3 bottom-menu">
            <button @click="toggleMenu(true)" class="duration-100 ease-in-out w-6/12 text-indigo-500 p-0 flex flex-row justify-center items-center gap-1">
              <svg class="w-5 h-5 fill-current" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <title>Menu</title>
                  <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
              </svg>
            </button>

            <div class="duration-100 ease-in-out w-6/12 text-indigo-500 flex flex-row justify-center items-center gap-1">
              <span @click="goTo('homepage')" v-if="customerSettings">
                <img :src="customerSettings.logo" class="welcome-page-logo-mobile" />
              </span>
            </div>

            <button class="duration-100 ease-in-out w-6/12 text-indigo-500 flex flex-row justify-center items-center gap-1" @click="openCartNavbar">
              <div class="relative inline-block font-medium text-gray-200 hover:text-white cursor-pointer" :class="{ 'text-gray-900 hover:text-gray-600': !scrolAtTop }">
                  <span class="block text-gray-800">
                    <svg class="flex-1 w-8 h-8 fill-current" viewbox="0 0 24 24">
                      <path d="M17,18C15.89,18 15,18.89 15,20A2,2 0 0,0 17,22A2,2 0 0,0 19,20C19,18.89 18.1,18 17,18M1,2V4H3L6.6,11.59L5.24,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H19V15H7.42A0.25,0.25 0 0,1 7.17,14.75C7.17,14.7 7.18,14.66 7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.58 17.3,11.97L20.88,5.5C20.95,5.34 21,5.17 21,5A1,1 0 0,0 20,4H5.21L4.27,2M7,18C5.89,18 5,18.89 5,20A2,2 0 0,0 7,22A2,2 0 0,0 9,20C9,18.89 8.1,18 7,18Z"/>
                      </svg>
                      <span class="absolute right-0 top-0 rounded-full bg-red-600 w-4 h-4 top right p-0 m-0 text-white font-mono text-sm  leading-tight text-center"> {{ cartItems.length }}
                    </span>
                  </span>

                  <span class="absolute bottom-0 left-0 inline-block w-full h-1 -mb-1 overflow-hidden">
                      <span x-show="hover" class="absolute inset-0 inline-block w-full h-1 h-full transform border-t-2 border-pink-500" x-transition:enter="transition ease-out duration-300" x-transition:enter-start="-translate-x-full" x-transition:enter-end="translate-x-0" x-transition:leave="transition ease-out duration-300" x-transition:leave-start="translate-x-0" x-transition:leave-end="translate-x-full"></span>
                  </span>
              </div>
            </button>

          </div>
        </div>
        <!-- End Mobile Bottom Menu -->

        <div v-if="customerSettings && customerSettings.setting" class="container flex items-center justify-center h-auto py-32 mx-auto">

            <div class="z-10 flex flex-col items-center px-8 xl:px-0">
                <h1 v-if="customerSettings.setting.welcomeSectionTitle" class="mx-6 mt-1 text-xl text-5xl font-black text-center text-white lg:text-6xl sm:text-center sm:mx-0">
                  {{ customerSettings.setting.welcomeSectionTitle }}                 
                </h1>
                <h1 v-else class="mx-6 mt-1 text-xl text-5xl font-black text-center text-white lg:text-6xl sm:text-center sm:mx-0">
                  {{ customerSettings.companyName }}           
                </h1>

                <div class="mt-3 space-x-1" v-if="customerSettings.setting.welcomeSectionEtoile && customerSettings.setting.welcomeSectionEtoile>0">
                  <div class="inline-block" v-for="index in Number(customerSettings.setting.welcomeSectionEtoile)" :key="index">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white inline" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                    </svg>
                  </div>
                </div>

                <p v-if="customerSettings.setting.welcomeSectionSubTitle" class="w-2/3 my-6 text-xl font-normal text-center text-gray-200">
                  {{ customerSettings.setting.welcomeSectionSubTitle }}
                </p>
                <p v-else class="w-2/3 my-6 text-xl font-normal text-center text-gray-200">
                  {{ customerSettings.companyAddress+', '+customerSettings.country }}
                </p>

                <div class="flex justify-center md:mt-10">
                    <a v-if="customerSettings.config && customerSettings.config.url_tarif && customerSettings.config.url_tarif!=''" :href="customerSettings.config.url_tarif" target="_blank" class="bg-secondary mr-2 rounded-lg hover:opacity-75 pl-5 pr-5 p-3 text-center text-base text-white font-bold rounded-md hover:bg-transparent">
                      <svg class="text-white inline mb-1 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M4 9.42h1.063C5.4 12.323 7.317 14 10.34 14c.622 0 1.167-.068 1.659-.185v-1.3c-.484.119-1.045.17-1.659.17-2.1 0-3.455-1.198-3.775-3.264h4.017v-.928H6.497v-.936c0-.11 0-.219.008-.329h4.078v-.927H6.618c.388-1.898 1.719-2.985 3.723-2.985.614 0 1.175.05 1.659.177V2.194A6.617 6.617 0 0 0 10.341 2c-2.928 0-4.82 1.569-5.244 4.3H4v.928h1.01v1.265H4v.928z"/>
                      </svg>
                      {{ $t('Pricing') }}
                    </a>
                    <button @click="goTo('product-list')" class="bg-primary rounded-lg hover:opacity-75 pl-5 pr-5 p-3 text-center text-base text-white font-bold rounded-md hover:bg-transparent">
                      <svg class="animate-bounce text-white inline h-5 w-5" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
                      </svg>
                      {{
                        customerSettings.setting && customerSettings.setting.welcomeSectionBtnName ?
                        customerSettings.setting.welcomeSectionBtnName :
                        'Découvrez nos Produits' 
                      }}
                    </button>
                </div>
            </div>

        </div>
    </section>
    
    <!-- Section 2 -->
    <section class="relative">
        <div class="relative h-48 px-10 bg-white lg:h-32">
            <form onsubmit="return false;" class="flex flex-col items-center h-auto max-w-lg p-6 mx-auto space-y-3 overflow-hidden transform -translate-y-12 bg-white rounded-lg shadow-md lg:h-24 lg:max-w-6xl lg:flex-row lg:space-y-0 lg:space-x-3">
                <div class="w-full h-12 border-2 border-gray-200 rounded-lg lg:border-0 lg:w-auto lg:flex-1">
                    <date-picker
                        name="start_date" 
                        type="datetime"
                        ref="start_date" 
                        v-model="startDate"
                        :default-value="new Date().setHours(new Date().getHours(), 0, 0, 0)"
                        :disabled-date="disabledStartDate"
                        :disabled-time="notBeforeStartTodayTime"
                        :time-picker-options="timePickerOptions"
                        format="DD/MM/YYYY HH:mm"
                        placeholder="date de départ"
                        data-vv-as="date de départ"
                        class="w-full h-full px-4 font-medium text-gray-700 rounded-lg sm:text-lg"
                        prefix-class="xmx"
                    ></date-picker>

                </div>
                <div class="w-0.5 bg-gray-100 h-10 lg:block hidden"></div>
                <div class="relative flex items-center w-full h-12 border-2 border-gray-200 rounded-lg lg:w-auto lg:border-0 lg:flex-1">
                    <date-picker
                        name="end_date" 
                        type="datetime"
                        ref="end_date" 
                        v-model="endDate"
                        :default-value="new Date().setHours(new Date().getHours(), 0, 0, 0)"
                        :disabled-date="disabledEndDate"
                        :disabled-time="notBeforeEndTime"
                        :disabled="startDate?false:true"
                        :time-picker-options="timePickerOptions"
                        format="DD/MM/YYYY HH:mm"
                        placeholder="date de retour"
                        data-vv-as="date de retour"
                        class="w-full h-full px-4 font-medium text-gray-700 rounded-lg sm:text-lg"
                        prefix-class="xmx"
                    ></date-picker>
                </div>
                <div class="w-full h-full lg:w-auto">
                    <button type="submit" @click="serachAvProduct()" class="bg-secondary rounded-lg hover:opacity-75 inline-flex items-center justify-center w-full h-full px-4 py-2 text-base font-medium leading-6 text-white whitespace-no-wrap border border-transparent rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 lg:w-64">
                      <svg v-show="!showSearchLoadingbtn" xmlns="http://www.w3.org/2000/svg" class="inline ml-1 mr-2 h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
                      </svg>
                      <div v-show="showSearchLoadingbtn" class="ml-2 mr-2 flex items-center justify-center">
                          <div class="w-5 h-5 border-b-2 border-white rounded-full animate-spin"></div>
                      </div>
                      Chercher
                    </button>
                </div>
            </form>
        </div>
    </section>

    <!-- Section 3 -->
    <section v-if="customerSettings.setting && customerSettings.setting.section1VideoThumbnail && customerSettings.setting.section1Title"
      class="relative flex flex-col items-center justify-center w-full px-6 py-12 bg-white bg-cover lg:py-12 min-w-screen">
        <div class="flex flex-col items-center justify-center p-8 sm:p-8 xl:p-8 lg:flex-row lg:max-w-6xl lg:p-0">
            <div class="relative w-full px-5 rounded-lg cursor-pointer lg:w-1/2 group xl:px-0">
                <div class="absolute top-0 left-0 w-11/12 -mt-20 opacity-50">
                    <svg class="w-full h-full ml-4 text-purple-100" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M45,-78C58.3,-70.3,69,-58.2,75.2,-44.4C81.3,-30.7,82.9,-15.3,83.5,0.4C84.2,16,83.8,32.1,76.5,43.9C69.2,55.7,55.1,63.3,41.2,69.4C27.3,75.4,13.6,80,-0.7,81.2C-15.1,82.5,-30.1,80.3,-41.2,72.6C-52.2,64.9,-59.2,51.6,-67.1,38.5C-75.1,25.5,-83.9,12.8,-83.8,0C-83.8,-12.7,-74.9,-25.4,-65.8,-36.4C-56.7,-47.4,-47.4,-56.7,-36.4,-65.7C-25.4,-74.7,-12.7,-83.5,1.6,-86.2C15.9,-89,31.8,-85.7,45,-78Z" transform="translate(100 100)"></path></svg>
                </div>
                <div class="relative overflow-hidden rounded-md shadow-2xl cursor-pointer group">
                    <div v-if="customerSettings.setting && customerSettings.setting.section1VideoUrl" class="absolute flex items-center justify-center w-full h-full">
                        <span class="flex items-center justify-center w-20 h-20 bg-primary rounded-full shadow-2xl" @click="videoPopUp=true">
                            <svg class="w-auto h-8 ml-1 text-white fill-current" viewBox="0 0 52 66" xmlns="http://www.w3.org/2000/svg"><path d="M50 30.7L4.1.6C2.6-.4.8.9.8 2.9v60.3c0 2 1.8 3.3 3.3 2.3L50 35.3c1.5-1 1.5-3.6 0-4.6z" fill-rule="nonzero"></path></svg>
                        </span>
                    </div>
                    <img v-if="customerSettings.setting.section1VideoThumbnail" :src="customerSettings.setting.section1VideoThumbnail" class="z-10 object-cover w-full h-full">
                </div>
            </div>

            <div class="container relative z-20 flex flex-col w-full px-5 pb-1 pr-12 mb-16 text-2xl text-gray-700 lg:w-1/2 sm:pr-0 md:pr-6 md:pl-0 lg:pl-5 xl:pr-10 sm:items-center lg:items-start lg:mb-0">
                <h1 v-if="customerSettings.setting.section1Title" class="relative z-20 text-5xl font-extrabold leading-none text-gray-800 xl:text-4xl sm:text-center lg:text-left">
                    {{ customerSettings.setting.section1Title }} <br>
                    <span v-if="customerSettings.setting.section1SubTitle" class="mt-1 text-primary lg:mt-0">{{ customerSettings.setting.section1SubTitle }}</span>
                </h1>
                
                <div v-html="customerSettings.setting.section1Text" class="relative z-20 block mt-6 text-base text-gray-500 xl:text-base text-justify	sm:text-center lg:text-left"></div>
            </div>
        </div>
    </section>

    <!-- Section 4 -->
    <section v-if="customerSettings.setting" class="flex flex-col w-full overflow-hidden bg-white lg:flex-row sm:mx-auto">
        <div class="flex justify-end pt-2 p-8 bg-white lg:py-32 lg:px-16 lg:pl-10 lg:w-1/2">
            <div class="flex flex-col items-start justify-center w-full lg:max-w-lg">
                <h5 v-if="customerSettings.setting.section2Title" class="relative pb-4 z-20 text-5xl font-extrabold leading-none text-primary xl:text-4xl sm:text-center lg:text-left">
                  {{ customerSettings.setting.section2Title }}
                </h5>

                <div v-html="customerSettings.setting.section2Text" class="relative z-20 block mt-6 text-base text-gray-500 xl:text-base text-justify	sm:text-center lg:text-left"></div>
            </div>
        </div>
        <div class="relative lg:w-1/2">
            <img :src="customerSettings.setting.section2Image">
        </div>
    </section>

    <!-- Section 1 -->
    <section class="w-full bg-gray-100" id="product-list" ref="product-list">
      <ProductsList :isValidatedStep1="setIsValidatedStep1"></ProductsList>
    </section>

    <!-- Section 5 -->
    <section ref="contact" class="relative py-0 bg-white mt-4 lg:py-20">

        <div class="flex flex-col items-center justify-between sm:px-10 mx-auto max-w-7xl xl:px-5 lg:flex-row">

            <div class="flex flex-col items-center w-full sm:px-10 pt-5 pb-20 lg:pt-20 lg:flex-row">

              <div class="relative z-10 w-full max-w-2xl mt-20 lg:mt-0 lg:w-5/12">
                  <div class="relative z-10 flex flex-col items-start justify-start p-10 bg-white shadow-2xl rounded-xl">
                      <h4 class="w-full text-4xl font-medium leading-snug">Nous contacter</h4>
                      <div class="relative w-full mt-6 space-y-8">
                          <div class="relative">
                              <label class="absolute px-2 ml-2 -mt-3 font-medium text-gray-600 bg-white">Nom et prénom </label>
                              <input
                                type="text"
                                name="name"
                                v-model="name"
                                v-validate="'required'"
                                placeholder="Jean Léo"
                                class="block w-full px-4 py-4 mt-2 text-base placeholder-gray-400 bg-white border border-gray-300 rounded-md focus:outline-none focus:border-black"
                              >
                              <span class="text-danger text-sm">{{ errors.first('name') }}</span>
                          </div>
                          <div class="relative">
                              <label class="absolute px-2 ml-2 -mt-3 font-medium text-gray-600 bg-white">Email</label>
                              <input
                                type="text"
                                name="email"
                                v-model="email"
                                v-validate="'required'"
                                class="block w-full px-4 py-4 mt-2 text-base placeholder-gray-400 bg-white border border-gray-300 rounded-md focus:outline-none focus:border-black"
                                placeholder="votre@email.fr"
                              >
                              <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                          </div>
                          <div class="relative">
                              <label class="absolute px-2 ml-2 -mt-3 font-medium text-gray-600 bg-white">Message</label>
                              <textarea
                                rows="7"
                                name="message"
                                v-model="message"
                                v-validate="'required'"
                                class="block w-full px-4 py-4 mt-2 text-base placeholder-gray-400 bg-white border border-gray-300 rounded-md focus:outline-none focus:border-black"
                              ></textarea>
                              <span class="text-danger text-sm">{{ errors.first('message') }}</span>
                          </div>
                          <div class="relative cursor-pointer">
                              <a @click="validateSendEmail()" class="inline-block w-full px-5 py-4 text-xl font-medium text-center text-white transition duration-200 bg-primary rounded-lg hover:opacity-75 ease">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                                Envoyer
                              </a>
                          </div>

                      </div>

                  </div>
                  <svg class="absolute top-0 left-0 z-0 w-32 h-32 -mt-12 -ml-12 text-gray-200 fill-current" viewBox="0 0 91 91" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="1" fill-rule="evenodd"><g fill-rule="nonzero"><g><g><circle cx="3.261" cy="3.445" r="2.72"></circle><circle cx="15.296" cy="3.445" r="2.719"></circle><circle cx="27.333" cy="3.445" r="2.72"></circle><circle cx="39.369" cy="3.445" r="2.72"></circle><circle cx="51.405" cy="3.445" r="2.72"></circle><circle cx="63.441" cy="3.445" r="2.72"></circle><circle cx="75.479" cy="3.445" r="2.72"></circle><circle cx="87.514" cy="3.445" r="2.719"></circle></g><g transform="translate(0 12)"><circle cx="3.261" cy="3.525" r="2.72"></circle><circle cx="15.296" cy="3.525" r="2.719"></circle><circle cx="27.333" cy="3.525" r="2.72"></circle><circle cx="39.369" cy="3.525" r="2.72"></circle><circle cx="51.405" cy="3.525" r="2.72"></circle><circle cx="63.441" cy="3.525" r="2.72"></circle><circle cx="75.479" cy="3.525" r="2.72"></circle><circle cx="87.514" cy="3.525" r="2.719"></circle></g><g transform="translate(0 24)"><circle cx="3.261" cy="3.605" r="2.72"></circle><circle cx="15.296" cy="3.605" r="2.719"></circle><circle cx="27.333" cy="3.605" r="2.72"></circle><circle cx="39.369" cy="3.605" r="2.72"></circle><circle cx="51.405" cy="3.605" r="2.72"></circle><circle cx="63.441" cy="3.605" r="2.72"></circle><circle cx="75.479" cy="3.605" r="2.72"></circle><circle cx="87.514" cy="3.605" r="2.719"></circle></g><g transform="translate(0 36)"><circle cx="3.261" cy="3.686" r="2.72"></circle><circle cx="15.296" cy="3.686" r="2.719"></circle><circle cx="27.333" cy="3.686" r="2.72"></circle><circle cx="39.369" cy="3.686" r="2.72"></circle><circle cx="51.405" cy="3.686" r="2.72"></circle><circle cx="63.441" cy="3.686" r="2.72"></circle><circle cx="75.479" cy="3.686" r="2.72"></circle><circle cx="87.514" cy="3.686" r="2.719"></circle></g><g transform="translate(0 49)"><circle cx="3.261" cy="2.767" r="2.72"></circle><circle cx="15.296" cy="2.767" r="2.719"></circle><circle cx="27.333" cy="2.767" r="2.72"></circle><circle cx="39.369" cy="2.767" r="2.72"></circle><circle cx="51.405" cy="2.767" r="2.72"></circle><circle cx="63.441" cy="2.767" r="2.72"></circle><circle cx="75.479" cy="2.767" r="2.72"></circle><circle cx="87.514" cy="2.767" r="2.719"></circle></g><g transform="translate(0 61)"><circle cx="3.261" cy="2.846" r="2.72"></circle><circle cx="15.296" cy="2.846" r="2.719"></circle><circle cx="27.333" cy="2.846" r="2.72"></circle><circle cx="39.369" cy="2.846" r="2.72"></circle><circle cx="51.405" cy="2.846" r="2.72"></circle><circle cx="63.441" cy="2.846" r="2.72"></circle><circle cx="75.479" cy="2.846" r="2.72"></circle><circle cx="87.514" cy="2.846" r="2.719"></circle></g><g transform="translate(0 73)"><circle cx="3.261" cy="2.926" r="2.72"></circle><circle cx="15.296" cy="2.926" r="2.719"></circle><circle cx="27.333" cy="2.926" r="2.72"></circle><circle cx="39.369" cy="2.926" r="2.72"></circle><circle cx="51.405" cy="2.926" r="2.72"></circle><circle cx="63.441" cy="2.926" r="2.72"></circle><circle cx="75.479" cy="2.926" r="2.72"></circle><circle cx="87.514" cy="2.926" r="2.719"></circle></g><g transform="translate(0 85)"><circle cx="3.261" cy="3.006" r="2.72"></circle><circle cx="15.296" cy="3.006" r="2.719"></circle><circle cx="27.333" cy="3.006" r="2.72"></circle><circle cx="39.369" cy="3.006" r="2.72"></circle><circle cx="51.405" cy="3.006" r="2.72"></circle><circle cx="63.441" cy="3.006" r="2.72"></circle><circle cx="75.479" cy="3.006" r="2.72"></circle><circle cx="87.514" cy="3.006" r="2.719"></circle></g></g></g></g></svg>
                  <svg class="absolute bottom-0 right-0 z-0 w-32 h-32 -mb-12 -mr-12 text-primary fill-current" viewBox="0 0 91 91" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="1" fill-rule="evenodd"><g fill-rule="nonzero"><g><g><circle cx="3.261" cy="3.445" r="2.72"></circle><circle cx="15.296" cy="3.445" r="2.719"></circle><circle cx="27.333" cy="3.445" r="2.72"></circle><circle cx="39.369" cy="3.445" r="2.72"></circle><circle cx="51.405" cy="3.445" r="2.72"></circle><circle cx="63.441" cy="3.445" r="2.72"></circle><circle cx="75.479" cy="3.445" r="2.72"></circle><circle cx="87.514" cy="3.445" r="2.719"></circle></g><g transform="translate(0 12)"><circle cx="3.261" cy="3.525" r="2.72"></circle><circle cx="15.296" cy="3.525" r="2.719"></circle><circle cx="27.333" cy="3.525" r="2.72"></circle><circle cx="39.369" cy="3.525" r="2.72"></circle><circle cx="51.405" cy="3.525" r="2.72"></circle><circle cx="63.441" cy="3.525" r="2.72"></circle><circle cx="75.479" cy="3.525" r="2.72"></circle><circle cx="87.514" cy="3.525" r="2.719"></circle></g><g transform="translate(0 24)"><circle cx="3.261" cy="3.605" r="2.72"></circle><circle cx="15.296" cy="3.605" r="2.719"></circle><circle cx="27.333" cy="3.605" r="2.72"></circle><circle cx="39.369" cy="3.605" r="2.72"></circle><circle cx="51.405" cy="3.605" r="2.72"></circle><circle cx="63.441" cy="3.605" r="2.72"></circle><circle cx="75.479" cy="3.605" r="2.72"></circle><circle cx="87.514" cy="3.605" r="2.719"></circle></g><g transform="translate(0 36)"><circle cx="3.261" cy="3.686" r="2.72"></circle><circle cx="15.296" cy="3.686" r="2.719"></circle><circle cx="27.333" cy="3.686" r="2.72"></circle><circle cx="39.369" cy="3.686" r="2.72"></circle><circle cx="51.405" cy="3.686" r="2.72"></circle><circle cx="63.441" cy="3.686" r="2.72"></circle><circle cx="75.479" cy="3.686" r="2.72"></circle><circle cx="87.514" cy="3.686" r="2.719"></circle></g><g transform="translate(0 49)"><circle cx="3.261" cy="2.767" r="2.72"></circle><circle cx="15.296" cy="2.767" r="2.719"></circle><circle cx="27.333" cy="2.767" r="2.72"></circle><circle cx="39.369" cy="2.767" r="2.72"></circle><circle cx="51.405" cy="2.767" r="2.72"></circle><circle cx="63.441" cy="2.767" r="2.72"></circle><circle cx="75.479" cy="2.767" r="2.72"></circle><circle cx="87.514" cy="2.767" r="2.719"></circle></g><g transform="translate(0 61)"><circle cx="3.261" cy="2.846" r="2.72"></circle><circle cx="15.296" cy="2.846" r="2.719"></circle><circle cx="27.333" cy="2.846" r="2.72"></circle><circle cx="39.369" cy="2.846" r="2.72"></circle><circle cx="51.405" cy="2.846" r="2.72"></circle><circle cx="63.441" cy="2.846" r="2.72"></circle><circle cx="75.479" cy="2.846" r="2.72"></circle><circle cx="87.514" cy="2.846" r="2.719"></circle></g><g transform="translate(0 73)"><circle cx="3.261" cy="2.926" r="2.72"></circle><circle cx="15.296" cy="2.926" r="2.719"></circle><circle cx="27.333" cy="2.926" r="2.72"></circle><circle cx="39.369" cy="2.926" r="2.72"></circle><circle cx="51.405" cy="2.926" r="2.72"></circle><circle cx="63.441" cy="2.926" r="2.72"></circle><circle cx="75.479" cy="2.926" r="2.72"></circle><circle cx="87.514" cy="2.926" r="2.719"></circle></g><g transform="translate(0 85)"><circle cx="3.261" cy="3.006" r="2.72"></circle><circle cx="15.296" cy="3.006" r="2.719"></circle><circle cx="27.333" cy="3.006" r="2.72"></circle><circle cx="39.369" cy="3.006" r="2.72"></circle><circle cx="51.405" cy="3.006" r="2.72"></circle><circle cx="63.441" cy="3.006" r="2.72"></circle><circle cx="75.479" cy="3.006" r="2.72"></circle><circle cx="87.514" cy="3.006" r="2.719"></circle></g></g></g></g></svg>
              </div>

              <div v-if="customerSettings && customerSettings.setting" class="relative w-full max-w-md bg-cover lg:max-w-2xl lg:w-7/12">
                  <div class="relative flex flex-col items-center justify-center w-full h-full lg:pr-10">
                      <img :src="customerSettings.setting.contactSectionImage">
                  </div>
              </div>

            </div>

        </div>

    </section>

    <Footer
      class="mt-10"
      v-on:goToSectionById="onGoToSectionById"
      :isHomePage="true"
      ></Footer>

    <div id="lowest-element" data-iframe-height=""></div>
  </div>

</template>



<script>
// DatePicker
import DatePicker from 'vue2-datepicker';
// import 'vue2-datepicker/index.css';
import '@/assets/scss/datepicker.scss'
import moment from 'moment';
import axios from '@/axios.js'

const ProductsList = () => import("@/views/welcome-page/ProductsList.vue");
const CartItems = () => import("@/views/welcome-page/CartItems.vue");
const Navbar = () => import("@/views/welcome-page/Navbar.vue");
const Footer = () => import("@/views/welcome-page/Footer.vue");
const VideoPopup = () => import("@/views/welcome-page/VideoPopup.vue");

import moduleSettingManagement from '@/store/settings/moduleSettingManagement.js'
import moduleReservationManagement from '@/store/reservation-management/moduleReservationManagement.js'

import { Validator } from 'vee-validate';
const dictionary = {
  en: {
    name: {
      required: 'required'
    }
  },
  fr: {
    name: {
      required: 'obligatoire'
    }
  }
};
Validator.localize(dictionary)
Validator.localize('fr')

export default {
  name: "WelcomPage",
  data: () => ({
    popupActivo4: false,
    setIsValidatedStep1: true,
    showSearchLoadingbtn: false,

    /** DateTime */
    startDate: '',
    endDate:'',
    startTime: '',
    endTime: '',
    scrolAtTop: true,
    showMobileMenu: true,

    showProductCartPopupActive: false,

    videoPopUp: false,

    popupSelectedQty: 1,

    // contact form
    name: '' ,
    email: '' ,
    message: '' 
  }),

  computed: {
    windowTop: {
      get() { 
        return this.$store.state.windowTop; 
      },
      set(val) { 
        this.$store.commit('SET_WINDOW_TOP', val) 
      }
    },
    showMenu: {
      get() { 
        return this.$store.state.showMenu; 
      },
      set(val) { 
        this.$store.commit('SET_SHOW_MENU', val) 
      }
    },
    customerSettings () {
      return this.$store.state.settingManagement.customerSetting
    },
    timePickerOptions() {
      return {
        start: typeof(this.customerSettings.config) !== 'undefined' ? (this.customerSettings.config.startTime):'08:30',
        step: typeof(this.customerSettings.config) !== 'undefined' ? (this.customerSettings.config.TimeStep):'00:15',
        end: typeof(this.customerSettings.config) !== 'undefined' ? (this.customerSettings.config.endTime):'18:00',
      }
      
    },
    cartNavbar: function() {
      return this.$store.state.cartNavbar;
    },
    cartItems () {
      return this.$store.state.eCommerce.cartItems
    },
    avProductsList () {
      return this.$store.state.eCommerce.avProductsList
    },
    modeBorneIsActive() {
      return localStorage.getItem('modeBorneIsActive') ? true : false
    }
  },
  watch: {
    windowTop(val) {
      console.log('windowTop val', val)
      this.scrolAtTop = (val > 200) ? false : true
      this.showMobileMenu = (val > 2000) ? false : true
    }
  },
  components: {
    VideoPopup,
    DatePicker,
    ProductsList,
    CartItems,
    Navbar,
    Footer
  },
  methods: {
    addSelectedStartEndDateTimeInCart (item) {
      this.$store.dispatch('eCommerce/addSelectedStartEndDateTimeInCart', item)
    },
    openCartNavbar() {
      this.$store.commit("IS_CART_NAVBAR_ACTIVE", true);
    },
    goTo(refName) {
      var element = this.$refs[refName];
      if(typeof element == 'undefined') return
      var top = element.offsetTop;
      window.scrollTo(0, top);
      this.toggleMenu(false)
    },
    onGoToSectionById(val) {
      this.goTo(val)
    },
    toggleMenu(val) {
      this.$store.commit("SET_SHOW_MENU", val);
    },
    toggleVideoPopUp (val = false) {
      this.videoPopUp = val
    },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    notBeforeStartTodayTime(date) {
      const startFrom = new Date();
      let startTimeToday = (localStorage.getItem('modeBorneIsActive') == "true" || localStorage.getItem('modeBorneIsActive') == true) ? 1:8;
      let start = startFrom.getHours() + startTimeToday
      const getStartTimeRepos = typeof(this.customerSettings.config.startTimeRepos) !== 'undefined' ? this.customerSettings.config.startTimeRepos : null
      const getEndTimeRepos = typeof(this.customerSettings.config.endTimeRepos) !== 'undefined' ? this.customerSettings.config.endTimeRepos : null
      if (getStartTimeRepos != null && getEndTimeRepos != null){
        return date < new Date(new Date().setHours(start, 0, 0, 0)) || (date.getHours()+ ':' + date.getMinutes() < getEndTimeRepos && date.getHours() + ':' + date.getMinutes() >= getStartTimeRepos);
      }else{
        return date < new Date(new Date().setHours(start, 0, 0, 0));
      }
    },
    notBeforeEndTime(date) {
      const getStartTimeRepos = typeof(this.customerSettings.config.startTimeRepos) !== 'undefined' ? this.customerSettings.config.startTimeRepos : null
      const getEndTimeRepos = typeof(this.customerSettings.config.endTimeRepos) !== 'undefined' ? this.customerSettings.config.endTimeRepos : null
      if (getStartTimeRepos != null && getEndTimeRepos != null){
        return date.getHours() + ':' + date.getMinutes() < getEndTimeRepos && date.getHours() + ':' + date.getMinutes() >= getStartTimeRepos;
      }
    },
    disabledStartDate(date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // const getStartDateFrom = typeof(this.customerSettings.config.startDateFrom) !== 'undefined' ? this.customerSettings.config.startDateFrom : 1
        // console.log('getStartDateFrom', getStartDateFrom)

        const getStartDateFrom = 0

        const startFrom = new Date(today);
        startFrom.setDate(startFrom.getDate() + getStartDateFrom);
        
        const numberOfDays = 270

        if(this.endDate != null && this.endDate != '') {
            return date < startFrom || date > this.endDate || date > new Date(startFrom.getTime() + numberOfDays * 24 * 3600 * 1000);
        }

        return date < startFrom || date > new Date(startFrom.getTime() + numberOfDays * 24 * 3600 * 1000);
    },
    disabledEndDate(date) {
      const startFrom = this.startDate
      const numberOfDays = 270
      return date < startFrom || date > new Date(startFrom.getTime() + numberOfDays * 24 * 3600 * 1000);
    },
    serachAvProduct() {
        console.log('serachAvProduct startDate', this.startDate)
        console.log('serachAvProduct endDate', this.endDate)

        let startDate = moment(this.startDate).format('YYYY-MM-DD')
        let startTime = moment(this.startDate).format('HH:mm')
        
        let endDate = moment(this.endDate).format('YYYY-MM-DD')
        let endTime = moment(this.endDate).format('HH:mm')

        console.log('startDate', startDate)
        console.log('startTime', startTime)
        console.log('endDate', endDate)
        console.log('endTime', endTime)
        
        const selectedStartEndDateTime = {
          startDate: this.startDate,
          endDate: this.endDate,
          startTime: this.startDate,
          endTime: this.endDate,
        }

        this.addSelectedStartEndDateTimeInCart(selectedStartEndDateTime)

        this.getAvProduct(null, 1)
    },
    openLoading (){
      this.$vs.loading()
    },
    closeLoading (){
      this.$vs.loading.close()
      this.$store.commit('eCommerce/TOGGLE_LOADING_AV_PRODUCT_LIST', false)
    },
    getAvProduct(productID = null, qty= null) {
      this.$store.commit('eCommerce/TOGGLE_LOADING_AV_PRODUCT_LIST', true)

        this.showSearchLoadingbtn = true
        
        try {
          const params = {}

          let startDate = moment(this.startDate).format('YYYY-MM-DD')
          let startTime = moment(this.startDate).format('HH:mm')
          let endDate = moment(this.endDate).format('YYYY-MM-DD')
          let endTime = moment(this.endDate).format('HH:mm')

          params['startDate'] = startDate
          params['startTime'] = startTime
          params['endDate'] = endDate
          params['endTime'] = endTime

          if(productID) {

            params['quantity'] = qty ? qty : this.popupSelectedQty
            params['product_id'] = productID 
          }

          axios.get(`/api/v2/checkavailibilityproducts`, { params: params })
            .then((response) => {
              console.log('response', response)
              if(productID) {
                // this.showProductCartPopup = response.data[0]
                this.closeLoading()
                this.showSearchLoadingbtn = false
              }
              else {
                this.$store.commit('eCommerce/ADD_AV_PRODUCT_LIST', response.data.data)
                this.$store.commit('eCommerce/ADD_DATE_DIFF', response.data.dateDifference)
                this.closeLoading()
                this.goTo('product-list')
                this.setIsValidatedStep1 = true
                this.showSearchLoadingbtn = false
              }
            })
            .catch((error) => {
              this.closeLoading()
              this.showSearchLoadingbtn = false
              
              if(error.response.status == 422) {
                let errors = Object.values(error.response.data.errors) 
                errors.forEach(error => 
                  this.$vs.notify({
                    time: 8000,
                    title: 'Erreur',
                    text: error[0],
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger',
                    position:'top-right'
                  })
                );
              }
          })

        } catch(e) {
          console.log('e', e)
          return null
        }
    },
    toggleDataIsPoupupAddAndEditActive (val = false) {
    this.showProductCartPopupActive = val
    },
    checkIfStartEndDateTimeIsValid() {
      if( this.startDate != null &&
          this.startTime != null &&
          this.endDate != null &&
          this.endTime != null
        ) {

        let startDate = moment(this.startDate).format('YYYY-MM-DD')
        let startTime = moment(this.startTime).format('HH:mm')
        
        let endDate = moment(this.endDate).format('YYYY-MM-DD')
        let endTime = moment(this.endTime).format('HH:mm')
  
        let startDateTime = moment(startDate + " " + startTime);
        let endDateTime = moment(endDate + " " + endTime);

        return endDateTime.diff(startDateTime, 'minutes') > 0 ? true : false
      }
      return true
    },
    validateSendEmail () {
      console.log('validateSendEmail')
      this.$validator.validateAll().then(result => {
        console.log('result', result)
        if (result) {
          this.sendEmail()
        } 
        return false
      })
    },
    sendEmail() {
      const payload = {
        contactForm : {
          name: this.name,
          email: this.email,
          message: this.message,
        },
        loading: this.$vs.loading,
        notify: this.$vs.notify,
      }
      this.$store.dispatch('reservationManagement/sendMailContactForm', payload)
      .then(res => {
        console.log('res', res)
        this.name = ''
        this.email = ''
        this.message = ''
        this.$validator.reset();
        this.$vs.loading.close()
      })
      .catch(err => {
        console.error(err)
        this.$vs.loading.close()
      })
    }

  },
  mounted() {
    const plugin = document.createElement("script");
    plugin.setAttribute(
      "src",
      "https://cdnjs.cloudflare.com/ajax/libs/alpinejs/2.8.0/alpine.js"
    );
    plugin.async = true;
    document.head.appendChild(plugin);
    this.goTo(this.$route.params.pathMatch);
    
    const iframeResizer = document.createElement("script");
    iframeResizer.setAttribute(
      "src",
      "https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.1.1/iframeResizer.contentWindow.min.js"
    );
    iframeResizer.async = true;
    document.head.appendChild(iframeResizer);

    window.iFrameResizerConfigured = false;
    window.iFrameResizer = {
      readyCallback : function(){
        console.log("readyCallback : iFrameResizerConfigured = true");
        window.iFrameResizerConfigured = true
      }
    }

    // this line to set primary color in the reservation Side
    this.$vs.theme({ primary: this.$store.state.themeColor });
    this.$vs.theme({ secondary: '#2e3c46' });
  },
  created () {
    if (!moduleSettingManagement.isRegistered) {
      this.$store.registerModule('settingManagement', moduleSettingManagement)
      moduleSettingManagement.isRegistered = true
    }
    if (!moduleReservationManagement.isRegistered) {
      this.$store.registerModule('reservationManagement', moduleReservationManagement)
      moduleReservationManagement.isRegistered = true
    }
  }
};
</script>

<style lang="css">

html {
  scroll-behavior: smooth;
}

.text-primary{
  --tw-text-opacity: 1;
  color: rgba(var(--vs-primary), 1)!important;
}

.bg-primary, a.bg-primary:hover, a.bg-primary:focus, button.bg-primary:hover, button.bg-primary:focus{
    --tw-bg-opacity: 1;
    background-color: rgba(var(--vs-primary), 1)!important;
}

.bg-secondary, a.bg-secondary:hover, a.bg-secondary:focus, button.bg-secondary:hover, button.bg-secondary:focus{
    --tw-bg-opacity: 1;
    background-color: rgba(var(--vs-secondary), 1)!important;
}

.bg-primary-border {
    border: 1px solid rgba(var(--vs-primary),1);
    background: transparent!important;
    color: rgba(var(--vs-primary),1);
}

.bottom-menu{
  box-shadow: 0 0 15px rgb(0 0 0 / 20%);
}

@media (max-width: 640px){
  .sm\:custom-hidden {
      visibility: hidden;
  }
  .welcome-page-logo-mobile{
    max-width: 100%;
    height: 50px;
  }
}

@import "https://unpkg.com/tailwindcss@2.0.2/dist/tailwind.min.css";

</style>